const BookingWidget = () => {
  return (
    <div className="fixed bottom-4 right-4 z-[100]">
      <ms-booking username="bobarbers"></ms-booking>
    </div>
  );
};

export default BookingWidget;
